export default {
  methods: {
    getUrlFromNestedParents(category) {
      if (category.count_parents_recursive == 0) {
        return this.localePath({
          name: 'categories-domain',
          params: { domain: category.slug },
        })
      }
      if (
        category.count_parents_recursive == 1 &&
        category.nested_parents
      ) {
        return this.localePath({
          name: 'categories-domain-category',
          params: {
            domain: category.nested_parents.slug,
            category: category.slug,
          },
        })
      }
      if (
        category.count_parents_recursive == 2 &&
        category.nested_parents &&
        category.nested_parents.nested_parents
      ) {
        return this.localePath({
          name: 'categories-domain-category-subcategory',
          params: {
            domain: category.nested_parents.nested_parents.slug,
            category: category.nested_parents.slug,
            subcategory: category.slug,
          },
        })
      }
      return this.localePath({ name: 'categories' })
    },
  },
}
